import { useCallback, useContext, useEffect } from "react"
import ModelElements from "../ModelElements"
import type { ProductModelProps } from "../ModelViewerProduct"
import ProductTextureContext from "../_contexts/ProductTextureContext"
import useGLB, { HasStandardMaterial } from "../_hooks/useGLB"
import { FindMaterialApprox } from "../../Common/Utils/ThreeTools"
import { Color, Object3D, Object3DEventMap } from "three"

export default function PrintedPatch(props: ProductModelProps) {
    /* Gotta load all the models this way because dynamic paths in URL() aren't picked up by webpack */
    const getUrl = useCallback(() => {
        return {
            'circle_2': new URL('@resources/3d-models/glb/printed-patch-circle_2.glb', import.meta.url),
            'circle_2_5': new URL('@resources/3d-models/glb/printed-patch-circle_2_5.glb', import.meta.url),
            'oval_2_75': new URL('@resources/3d-models/glb/printed-patch-oval_2_75.glb', import.meta.url),
            'oval_3_5': new URL('@resources/3d-models/glb/printed-patch-oval_3_5.glb', import.meta.url),
            'rectangle_2_75': new URL('@resources/3d-models/glb/printed-patch-rectangle_2_75.glb', import.meta.url),
            'rectangle_3_5': new URL('@resources/3d-models/glb/printed-patch-rectangle_3_5.glb', import.meta.url),
            'square_2': new URL('@resources/3d-models/glb/printed-patch-square_2.glb', import.meta.url),
            'square_2_5': new URL('@resources/3d-models/glb/printed-patch-square_2_5.glb', import.meta.url),
        }[props.variant]
    }, [props.variant])

    const model = useGLB(getUrl() ?? new URL('@resources/3d-models/glb/printed-patch-circle_2.glb', import.meta.url))
    const elements = model.scene.children
    const [productTexture] = useContext(ProductTextureContext)

    // Contrast is kinda high, making the sides look way too dark, this lightens them
    useEffect(() => {
        const sideMaterial = FindMaterialApprox('dark', elements[0].children as Object3D<Object3DEventMap>[] & HasStandardMaterial[])
        if (sideMaterial) sideMaterial.color = new Color(0x4C413D);
    }, [elements])

    // Apply lab texture
    useEffect(() => {
        const designMaterial = FindMaterialApprox('design', elements)
        if (designMaterial) {
            designMaterial.map = productTexture
            designMaterial.map.flipY = false
            designMaterial.map.needsUpdate = true
        }
    }, [productTexture, elements])
    
    return <ModelElements scene={model.scene} forceUpdate={props.variant}/>
}
